import classNames from 'classnames';
import React, { useLayoutEffect, useRef, useState } from 'react';
import { Link } from '../utils/router/v3Bridge';
import styles from './Breadcrumb.module.scss';
import Caret from './Caret';

const MIN_WIDTH = parseInt(styles.minWidth, 10);

interface BreadcrumbProps {
  name: React.ReactNode;
  to?: string;
  truncate?: boolean;
  priority?: 'max' | 'high' | 'low';
}

const Breadcrumb = ({
  name,
  to,
  truncate = false,
  priority = 'low',
}: BreadcrumbProps) => {
  const ref = useRef<HTMLLIElement>(null);
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const [needsMinWidth, setNeedsMinWidth] = useState(false);

  useLayoutEffect(() => {
    if (truncate && ref.current && ref.current.clientWidth > MIN_WIDTH) {
      setNeedsMinWidth(true);
    }
  }, [truncate]);

  return (
    <li
      className={classNames(styles.container, {
        [styles.needsMinWidth]: needsMinWidth,
        [styles.maxPriority]: priority === 'max',
        [styles.highPriority]: priority === 'high',
        [styles.truncate]: truncate,
      })}
      ref={ref}
    >
      <div className={styles.name}>
        {to ? <Link to={to}>{name}</Link> : name}
      </div>
      <div className={styles.caret}>
        <Caret direction="right" size={6} />
      </div>
    </li>
  );
};

export default Breadcrumb;
